<div class="dl-absolute-fill-in-overflow">
  <!-- status info spinner -->
  <div *ngIf="loading" class="d-flex align-items-center justify-content-center dl-spinner">
    <mat-spinner></mat-spinner>
  </div>
  <!-- status info block -->
  <div class="d-flex flex-row dl-data-summary-container" *ngIf="!loading && info">
    <!-- collections -->
    <div *ngIf="info.collections" class="d-flex flex-column dl-summary-block">
      <div>
        <!-- title -->
        <div class="dl-summary-header">
          {{getTitleFirstPart(collectionTitle)}}
          <span class="dl-no-wrap">
            {{getTitleSecondPart(collectionTitle)}}
            <mat-icon aria-hidden="false"
              matTooltip="{{info.collections.subTitle | default:'Module for defining data to be collected from a 3rd party.'}}"
              aria-label="info_outline" class="dl-header-tooltip-icon icon-dark">
              info_outline
            </mat-icon>
          </span>
        </div>
        <!-- total -->
        <div class="d-flex flex-row dl-summary-row">
          <div class="dl-summary-item-key">Total</div>
          <div class="d-flex dl-summary-item-value dl-collection-status-total">
            {{info.collections.total}}
          </div>
        </div>
        <!-- counts -->
        <div *ngFor="let item of info.collections.statusInfo" class="d-flex flex-row dl-summary-row">
          <div class="dl-summary-item-key">{{item.status}}</div>
          <div class="d-flex dl-summary-item-value dl-collection-status-{{item.status.toLowerCase()}}">
            {{item.count}}
          </div>
        </div>
      </div>
      <!-- buttons -->
      <div class="d-flex dl-summary-actions">
        <button *ngIf="canCreateCollection()" type="button" class="btn dl-btn dl-btn-primary"
          routerLink="/data-collections/create" routerLinkActive="active">
          Create Collection
        </button>
        <button type="button" class="btn dl-btn dl-btn-secondary" routerLink="/data-collections"
          routerLinkActive="active">
          View Collections
        </button>
      </div>
    </div>
    <div class="d-flex dl-summary-divider"></div>
    <!-- requests -->
    <div *ngIf="info.requests" class="d-flex flex-column dl-summary-block">
      <div>
        <!-- title -->
        <div class="dl-summary-header">
          {{getTitleFirstPart(requestTitle)}}
          <span class="dl-no-wrap">
            {{getTitleSecondPart(requestTitle)}}
            <mat-icon aria-hidden="false"
              matTooltip="{{info.requests.subTitle | default:'Module for requesting access to data from a Data Collection for a specified purpose.'}}"
              aria-label="info_outline" class="dl-header-tooltip-icon icon-dark">
              info_outline
            </mat-icon>
          </span>
        </div>
        <!-- total -->
        <div class="d-flex flex-row dl-summary-row">
          <div class="dl-summary-item-key">Total</div>
          <div class="d-flex dl-summary-item-value dl-collection-status-total">
            {{info.requests.total}}
          </div>
        </div>
        <!-- counts -->
        <div *ngFor="let item of info.requests.statusInfo" class="d-flex flex-row dl-summary-row">
          <div class="dl-summary-item-key">{{item.status}}</div>
          <div class="d-flex dl-summary-item-value dl-request-status-{{item.status.toLowerCase()}}">
            {{item.count}}
          </div>
        </div>
      </div>
      <!-- buttons -->
      <div class="d-flex dl-summary-actions">
        <button *ngIf="canCreateRequest()" type="button" class="btn dl-btn dl-btn-primary"
          routerLink="/data-utilization/create" routerLinkActive="active">
          Create Request
        </button>
        <button type="button" class="btn dl-btn dl-btn-secondary" routerLink="/data-utilization"
          routerLinkActive="active">
          View Requests
        </button>
      </div>
    </div>
    <div class="dl-summary-divider"></div>
    <!-- uploads -->
    <div *ngIf="info.uploads" class="d-flex flex-column dl-summary-block">
      <div>
        <!-- title -->
        <div class="dl-summary-header">
          {{getTitleFirstPart(uploadTitle)}}
          <span class="dl-no-wrap">
            {{getTitleSecondPart(uploadTitle)}}
            <mat-icon aria-hidden="false"
              matTooltip="{{info.uploads.subTitle | default:'Module to upload data to a Data Collection.'}}"
              aria-label="info_outline" class="dl-header-tooltip-icon icon-dark">
              info_outline
            </mat-icon>
          </span>
        </div>
        <!-- total -->
        <div class="d-flex flex-row dl-summary-row">
          <div class="dl-summary-item-key">Total</div>
          <div class="d-flex dl-summary-item-value dl-collection-status-total">
            {{info.uploads.total}}
          </div>
        </div>
        <!-- counts -->
        <div *ngFor="let item of info.uploads.statusInfo" class="d-flex flex-row dl-summary-row">
          <div class="dl-summary-item-key">{{item.status}}</div>
          <div class="d-flex dl-summary-item-value dl-upload-status-{{item.status.toLowerCase()}}">
            {{item.count}}
          </div>
        </div>
      </div>
      <!-- buttons -->
      <div class="d-flex dl-summary-actions">
        <button *ngIf="canCreateUpload()" type="button" class="btn dl-btn dl-btn-primary"
          routerLink="/data-uploads/upload" routerLinkActive="active">
          Upload Data
        </button>
        <button type="button" class="btn dl-btn dl-btn-secondary" routerLink="/data-uploads" routerLinkActive="active">
          View Uploads
        </button>
      </div>
    </div>
  </div>

  <!-- table title -->
  <div class="d-flex align-items-center dl-page-header">
    <div class="d-flex flex-row dl-page-title">
      <div>
        {{config?.title | default:'My Work Items'}}
      </div>
    </div>
  </div>

  <!-- table -->
  <app-work-item-table *ngIf="config"
    [workItemService]="homeService"
    [tableConfiguration]="config">
  </app-work-item-table>
</div>
